(function(a) {
  a.fn.prepareTransition = function() {
    return this.each(function() {
      var b = a(this);
      b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
        b.removeClass("is-transitioning")
      });
      var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
      var d = 0;
      a.each(c, function(a, c) {
        d = parseFloat(b.css(c)) || d
      });
      if (d != 0) {
        b.addClass("is-transitioning");
        b[0].offsetWidth
      }
    })
  }
})(jQuery);

function replaceUrlParam(e, r, a) {
  var n = new RegExp("(" + r + "=).*?(&|$)"),
      c = e;
  return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a
};
if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
}
window.timber = window.timber || {};
timber.cacheSelectors = function() {
  timber.cache = {
    $html: $('html'),
    $body: $('body'),
    $navigation: $('#AccessibleNav'),
    $mobileSubNavToggle: $('.mobile-nav__toggle'),
    $changeView: $('.change-view'),
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail'),
    $recoverPasswordLink: $('#RecoverPassword'),
    $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
    $recoverPasswordForm: $('#RecoverPasswordForm'),
    $customerLoginForm: $('#CustomerLoginForm'),
    $passwordResetSuccess: $('#ResetSuccess')
  };
};
timber.init = function() {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};
timber.accessibleNav = function() {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);
    if (!$el.hasClass(activeClass)) {
      //evt.preventDefault();
    }
    showDropdown($el);
  });
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });
  $subMenuLinks.on('touchstart', function(evt) {
    evt.stopImmediatePropagation();
  });
  $allLinks.focus(function() {
    handleFocus($(this));
  });
  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  function handleFocus($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown($el) {
    $el.addClass(activeClass);
    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus($el) {
    $el.addClass(focusClass);
  }

  function removeFocus($el) {
    $el.removeClass(focusClass);
  }
};
timber.drawersInit = function() {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left'); 
  
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  }); 
  
};
timber.mobileNavToggle = function() {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};
timber.getHash = function() {
  return window.location.hash;
};
timber.productPage = function(options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');
  if (variant) {
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }
    if (variant.available) {
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }
    $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
    if (variant.compare_at_price > variant.price) {
      $comparePrice.html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
    } else {
      $comparePrice.hide();
    }
  } else {
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};
timber.productImageSwitch = function() {
  if (timber.cache.$thumbImages.length) {
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};
timber.switchImage = function(src, imgObject, el) {
  var $el = $(el);
  $el.attr('src', src);
};
timber.responsiveVideos = function() {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  $iframeVideo.each(function() {
    $(this).wrap('<div class="video-wrapper"></div>');
  });
  $iframeReset.each(function() {
    this.src = this.src;
  });
};
timber.collectionViews = function() {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;
      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};
timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }
  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });
  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};
timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};
timber.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };
    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };
    this.config = $.extend(defaults, options);
    this.position = position;
    this.$drawer = $('#' + id);
    if (!this.$drawer.length) {
      return false;
    }
    this.drawerIsOpen = false;
    this.init();
  };
  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };
  Drawer.prototype.open = function(evt) {
    var externalCall = false;
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      this.$activeSource = $(evt.currentTarget);
    }
    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();
    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;
    this.trapFocus(this.$drawer, 'drawer_focus');
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    // code to close the drawer whenever user clicks outside the cartdrawer
    if(this.drawerIsOpen){
      this.$nodes.parent.on('click', $.proxy(function(event) {
        if(!$(event.target).closest("#CartDrawer").length) {
          this.close();
          //return false;
        }
      },this));
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }
    this.$nodes.page.on('touchmove.drawer', function() {
      return false;
    });
    this.$nodes.page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };
  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      return;
    }
    $(document.activeElement).trigger('blur');
    this.$nodes.moved.prepareTransition({
      disableExisting: true
    });
    this.$drawer.prepareTransition({
      disableExisting: true
    });
    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
    this.drawerIsOpen = false;
    this.removeTrapFocus(this.$drawer, 'drawer_focus');
    this.$nodes.page.off('.drawer');
  };
  Drawer.prototype.trapFocus = function($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.attr('tabindex', '-1');
    $container.focus();
    $(document).on(eventName, function(evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };
  Drawer.prototype.removeTrapFocus = function($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };
  return Drawer;
})();
$(timber.init);
$(document).ready(function(){
  $('.no-bullets.blog_categories li').each(function(){
    var val_tag = $(this).find('a').text();
    if(val_tag == 'Food As Medicine'){
      $(this).find('a').attr('title','Show articles tagged Food As Medicine');
    }
    else if(val_tag == 'Chinese Medicine'){
      $(this).find('a').attr('title','Show articles tagged Chinese Medicine');
    }
    else if(val_tag == 'Herbs'){
      $(this).find('a').attr('title','Show articles tagged Herbs');
    }

  });
  var breadcrumb = $('.tag_name').text();
  if (breadcrumb == 'Food Rx'){
    $('.tag_name').text("Food As Medicine");
  }
  if (breadcrumb == 'Chi Med'){
    $('.tag_name').text("Chinese Medicine");
  }
  if (breadcrumb == 'Herbal Formulas'){
    $('.tag_name').text("Herbs");
  }

  $('ul').find("[data-attr='title_10']").hover(
    function () {
      $(this).parents('div.site-nav__dropdown.dropdown-all-products').addClass("hide-desc");
      $(this).parents('body').addClass("remove-layer");
    },
    function () {
      $(this).parents('div.site-nav__dropdown.dropdown-all-products').removeClass("hide-desc");
      $(this).parents('body').removeClass("remove-layer");
    }
  );
});
